import React from "react";
import mark from "../assets/brand/nudo-mark-light.svg";

const Logo = () => {
  return (
    <div className="logo" aria-label="Nudo Lab">
      <img className="logo-mark" src={mark} alt="" />
      <span className="logo-word">Nudo Lab</span>
    </div>
  );
};

export default Logo;
